module.exports = __webpack_public_path__ + "img/facebook.700dba70.svg";